import { Swiper } from 'swiper';
import {Navigation, Pagination} from "swiper/modules";
Swiper.use([Navigation, Pagination]);

export default () => {
    const nodeSelectors = {
        container: '[js-counter-slider="container"]',
        slider: '[js-counter-slider="slider"]',
        pagination: '[js-counter-slider="pagination"]',
        prev: '[js-counter-slider="prev"]',
        next: '[js-counter-slider="next"]',
        play: '[js-counter-slider-play="play-button"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let counterSlider = new Swiper(sliderEl, {
                spaceBetween: 10,
                loop: true,
                speed: 500,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                },
                breakpoints: {
                    300: {
                        slidesPerView: 1,
                    },
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 2
                    },
                    // when window width is >= 640px
                    1024: {
                        slidesPerView: 3
                    },
                    1100: {
                        slidesPerView: 4
                    }
                }
            });
        })
    }

    return Object.freeze({
        init,
    })
}